import React from "react";
import Icon from "@/app/components/common/Icon";

function CollapsibleSection({
	title,
	number,
	right = null,
	rightContent = null,
	open = false,
	children,
	className = "",
	flat = false,
	marginBottom = "mb-8",
}) {
	const [isOpen, setIsOpen] = React.useState(() => open);
	return (
		<div
			className={`${flat ? "" : "bg-white shadow-md"} ${marginBottom} ${className} print:bg-none print:shadow-none print:p-0`}
		>
			<div
				className={
					"flex flex-col md:flex-row gap-4" +
					(isOpen ? " border-b border-grey-lightest" : "")
				}
			>
				{(title || !open) && (
					<button
						type="button"
						aria-expanded={isOpen}
						className={
							"flex-1 min-w-0 flex justify-between items-center px-4 py-8"
						}
						onClick={() => setIsOpen(!isOpen)}
					>
						<span className="rounded-full bg-grey-lightest mr-4 w-8 h-8 print:hidden">
							<Icon
								name="cyber-angle"
								size="2xl"
								className={`${
									isOpen ? "rotate-180" : ""
								} transition-transform`}
							/>
						</span>
						<span className="flex-1 flex items-center gap-4 text-3xl print:text-lg print:font-sans-wide font-bold">
							{number !== undefined && (
								<span className="text-the-brown">
									{number}.
								</span>
							)}
							<span className="flex items-center text-left">
								{title}
							</span>
						</span>
						{right}
					</button>
				)}
				{isOpen && rightContent != null && (
					<div className="p-2 md:p-4 flex justify-center items-center">
						{rightContent}
					</div>
				)}
			</div>
			<div
				className={`overflow-hidden overflow-x-scroll transition-all duration-200 ${
					isOpen ? "max-h-fit p-4" : "max-h-0 px-4"
				} print:max-h-none print:p-4`}
			>
				{children}
			</div>
		</div>
	);
}
export default CollapsibleSection;
